export const COMPONENT_MODAL_INIT = 'COMPONENT_MODAL_INIT'
export const COMPONENT_MODAL_TOGGLE = 'COMPONENT_MODAL_TOGGLE'